export const TRUE_STRING = "true";
const FALSE_STRING = "false";

export const booleanToString = (value: boolean): string => (value ? TRUE_STRING : FALSE_STRING);
